import { render, staticRenderFns } from "./upgrade-popup.vue?vue&type=template&id=0844cbe6&"
import script from "./upgrade-popup.vue?vue&type=script&lang=tsx&"
export * from "./upgrade-popup.vue?vue&type=script&lang=tsx&"
import style0 from "./upgrade-popup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports